import { defineMessages, defineMessage } from "react-intl";
import { CrudMessages, defaultCrudMessages } from "../shared/crud/simple-crud";

export const legalInfoMessages = defineMessages({
  entityName: {
    id: "legalinfo.entityName",
    defaultMessage: "Legal Info",
  },
  privacyPolicy: {
    id: "legalinfo.PRIVACY_POLICY",
    defaultMessage: "Privacy Policy",
  },
  communicationsPolicy: {
    id: "legalinfo.COMMUNICATIONS_POLICY",
    defaultMessage: "Communications Policy",
  },
  policyTypeHelpPrivacy: {
    id: "legalinfo.policyTypeHelpPrivacy",
    defaultMessage: "*Text which indicates compliance with LOPD and GDPR.",
  },
  policyTypeHelpCommunication: {
    id: "legalinfo.policyTypeHelpCommunication",
    defaultMessage:
      "*Text the user will read in order to accept receiving offers and promotions through email.",
  },
  translations: {
    id: "legalinfo.translations",
    defaultMessage: "Translations",
  },
  text: {
    id: "legalinfo.text",
    defaultMessage: "Text",
  },
});

export const messages: CrudMessages = {
  ...defaultCrudMessages,
  ...legalInfoMessages,
  tableHeaders: {
    hotelTicker: defineMessage({ id: "legalinfo.hotelTicker", defaultMessage: "Hotel Ticker" }),
    property: defineMessage({ id: "legalinfo.property", defaultMessage: "Policy Type" }),
  },
};
